import { render, staticRenderFns } from "./BrandDetectionReport.vue?vue&type=template&id=92f0de3a&scoped=true"
import script from "./BrandDetectionReport.vue?vue&type=script&lang=js"
export * from "./BrandDetectionReport.vue?vue&type=script&lang=js"
import style0 from "./BrandDetectionReport.vue?vue&type=style&index=0&id=92f0de3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f0de3a",
  null
  
)

export default component.exports